(function(){
  'use strict';
  var mode=window.SafeSThemeCheckoutMode;
  if(mode!=='ab') return;
  var hidden=document.createElement('button');hidden.type='button';hidden.hidden=true;hidden.setAttribute('data-safes-pay-button','');
  function init(){document.body.appendChild(hidden);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  function nativeCheckout(url){
    try{var u=new URL(url,location.origin);return u.origin===location.origin && /^\/checkouts?(?:\/|$)/.test(u.pathname);}catch(e){return false;}
  }
  document.addEventListener('click',function(e){
    var target=e.target.closest && e.target.closest("a[href],button,input[type='submit']");
    if(!target||target.disabled||target.closest('[data-safes-pay-button],[data-safes-pay-buy-now]'))return;
    if(target.name==='checkout'||nativeCheckout(target.getAttribute('href')||target.getAttribute('formaction')||'')){
      e.preventDefault();e.stopImmediatePropagation();hidden.click();
    }
  },true);
  document.addEventListener('submit',function(e){
    var f=e.target;if(!f||!f.getAttribute)return;
    var action=f.getAttribute('action')||'';
    var submitter=e.submitter;
    if(nativeCheckout(action)||(submitter&&submitter.name==='checkout')){
      e.preventDefault();e.stopImmediatePropagation();hidden.click();
    }
  },true);
})();
